module.exports = __webpack_public_path__ + "1850cad8bd492d75ed605a44a203ddd2.pdf";